import React from 'react';

interface Props {
	size: number;
}

export const FlexibilityIcon: React.FC<Props> = props => (
	<svg
		aria-hidden='true'
		height={props.size}
		viewBox='0 0 24 24'
		width={props.size}
		xmlns='http://www.w3.org/2000/svg'
	>
		<title>flexibility</title>
		<path d='M19.08 12.42H1A.46.46 0 01.58 12a.45.45 0 01.42-.49h18a.45.45 0 01.45.45.46.46 0 01-.37.46z' />
		<path d='M6.54 12.51h-1a.46.46 0 01-.39-.51.45.45 0 01.47-.43c3 .14 5.21-.39 6.35-1.47a2.72 2.72 0 00.86-2c0-3.89 2.26-4.94 4.17-5.1h5.68a.45.45 0 110 .9H17c-2.21.24-3.31 1.62-3.31 4.22a3.6 3.6 0 01-1.14 2.68c-1.16 1.11-3.24 1.71-6.01 1.71z' />
		<path d='M17.58 21H12.3c-2.65-.33-4-2.23-4-5.64 0-2.11-2-2.89-7.42-2.89a.46.46 0 110-.91c4.21 0 8.33.29 8.33 3.8 0 2.92 1 4.47 3.12 4.74h5.22a.45.45 0 110 .9zM20.86 6.1l-.64-.65 2.04-2.04-2.04-2.04.64-.65 2.69 2.69-2.69 2.69zM17.9 14.65l-.64-.65 2.04-2.04-2.04-2.04.64-.64 2.69 2.68-2.69 2.69z' />
		<path d='M16.27 23.28l-.64-.65 2.04-2.04-2.04-2.04.64-.65 2.69 2.69-2.69 2.69z' />
	</svg>
);
